import { Account } from '@/common/models';
import { QueryParams } from '@/common/models/query-params';
import OrgAppAPIProxy from '@/org-app/api';
import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
import { createGetAllQuery, createGetOneQuery } from '@/org-app/services/tanstack/queryUtils';
import orgAppStore from '@/org-app/store';
import { UPDATE_ACCOUNTS_LIST } from '@/org-app/store/modules/accounts/mutation-types';

export const useAccounts = createGetAllQuery<Account>(
  [queryKeys.accounts],
  () => OrgAppAPIProxy.instance.getAccountsAsync({ queryParams: QueryParams.all() }),
  (data) => {
    orgAppStore.modules.Accounts.mutations[UPDATE_ACCOUNTS_LIST](orgAppStore.modules.Accounts.state, data);
  },
);

export const useAccount = createGetOneQuery<Account>([queryKeys.account], (id) => {
  return OrgAppAPIProxy.instance.getAccount({
    id,
    queryParams: QueryParams.all(),
  });
});
